/* AQUON PDP Bundle - variant selectors, gallery, bundle picker, add-to-cart. */
(function () {
  'use strict';

  function moneyFormat(cents) {
    // Store money format ('₹ 1,080') through the shared helper from
    // snippets/bundle-freebies-config.liquid; the basic formatter is the fallback.
    if (window.AquonOffer && typeof window.AquonOffer.money === 'function') return window.AquonOffer.money(cents);
    var format = window.Shopify && Shopify.currency && Shopify.currency.money_format;
    var value = (cents / 100).toFixed(2);
    if (format) {
      // Basic replacement for common Shopify money formats
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, String(Math.round(cents / 100)));
    }
    return '₹' + value;
  }

  function svgPlus() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }
  function svgMinus() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  // Collapse the thumbnail column to the first N items on desktop, with a
  // thumbnail-styled +/- toggle that reveals the rest and lets the column scroll
  // internally (its height capped to the main image). No-op on mobile (the
  // horizontal scroller) and when there is nothing to collapse. Idempotent, so
  // it is safe to re-run after the thumbs are rebuilt on a flavour swap.
  function setupThumbExpand(sec) {
    var thumbsEl = sec.querySelector('[data-apdp-thumbs]') || sec.querySelector('.apdp__thumbs');
    if (!thumbsEl) return;
    var expandable = thumbsEl.getAttribute('data-expandable') !== 'false';
    var initial = parseInt(thumbsEl.getAttribute('data-initial'), 10);
    if (isNaN(initial) || initial < 1) initial = 6;
    var galleryEl = sec.querySelector('.apdp__gallery');
    var mq = window.matchMedia('(min-width: 750px)');
    var ro = null;
    var disposed = false;

    function cap() {
      if (disposed) return;
      if (galleryEl) thumbsEl.style.maxHeight = Math.round(galleryEl.getBoundingClientRect().height) + 'px';
    }

    function apply() {
      if (disposed) return;
      // Clean slate so re-runs (rebuild, breakpoint change) never stack state.
      var old = thumbsEl.querySelector('[data-apdp-thumb-toggle]');
      if (old) old.remove();
      var thumbs = Array.prototype.slice.call(thumbsEl.querySelectorAll('[data-apdp-thumb]'));
      thumbs.forEach(function (t) { t.classList.remove('apdp__thumb--overflow'); });
      thumbsEl.classList.remove('is-collapsible');
      thumbsEl.classList.remove('is-expanded');
      thumbsEl.style.maxHeight = '';
      // Hand the wheel back to Lenis when this isn't a live scroll area.
      thumbsEl.removeAttribute('data-scrollable');
      if (ro) { ro.disconnect(); ro = null; }

      // Nothing to do: disabled, on mobile, or few enough to show in full.
      if (!expandable || !mq.matches || thumbs.length <= initial) return;

      thumbsEl.classList.add('is-collapsible');
      // The theme's Lenis smooth-scroll prevents native scrolling on nested
      // elements unless they match LENIS_PREVENT_SELECTOR (utilities.js). Marking
      // the column [data-scrollable] lets the wheel scroll the thumbs, not the page.
      thumbsEl.setAttribute('data-scrollable', '');
      cap();
      thumbs.forEach(function (t, i) { if (i >= initial) t.classList.add('apdp__thumb--overflow'); });

      var hiddenCount = thumbs.length - initial;
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'apdp__thumb-toggle';
      toggle.setAttribute('data-apdp-thumb-toggle', '');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Show ' + hiddenCount + ' more product media item' + (hiddenCount === 1 ? '' : 's'));
      toggle.innerHTML = svgPlus();
      // Collapsed, the + sits right after the Nth thumbnail. Expanded, the -
      // moves to the very bottom, after the last thumbnail (not swapped in place).
      var anchor = thumbs[initial - 1];
      function placeCollapsed() {
        if (anchor && anchor.nextSibling) thumbsEl.insertBefore(toggle, anchor.nextSibling);
        else thumbsEl.appendChild(toggle);
      }
      placeCollapsed();

      toggle.addEventListener('click', function () {
        var expanded = thumbsEl.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.innerHTML = expanded ? svgMinus() : svgPlus();
        toggle.setAttribute('aria-label', expanded
          ? 'Show fewer product media items'
          : ('Show ' + hiddenCount + ' more product media item' + (hiddenCount === 1 ? '' : 's')));
        if (expanded) {
          thumbsEl.appendChild(toggle);
        } else {
          placeCollapsed();
          thumbsEl.scrollTop = 0;
        }
      });

      if (thumbs.some(function (thumb, index) { return index >= initial && thumb.classList.contains('is-active'); })) toggle.click();

      if (galleryEl && window.ResizeObserver) {
        ro = new ResizeObserver(function () { cap(); });
        ro.observe(galleryEl);
      }
    }

    apply();
    var onChange = function () { apply(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    // Let rebuildThumbs() re-collapse the fresh thumbs after a flavour swap.
    thumbsEl._apdpApplyExpand = apply;
    return function () {
      disposed = true;
      if (ro) ro.disconnect();
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else if (mq.removeListener) mq.removeListener(onChange);
      if (thumbsEl._apdpApplyExpand === apply) delete thumbsEl._apdpApplyExpand;
    };
  }

  function initSection(sec) {
    if (!sec || sec.dataset.apdpInit === '1') return;
    sec.dataset.apdpInit = '1';
    var disposed = false;
    var disposers = [];
    var timers = new Set();
    var frames = new Set();
    function later(callback, delay) {
      var id = setTimeout(function () { timers.delete(id); if (!disposed) callback(); }, delay);
      timers.add(id);
      return id;
    }
    function cancelLater(id) { clearTimeout(id); timers.delete(id); }
    function cancelFrame(id) { cancelAnimationFrame(id); frames.delete(id); }
    function frame(callback) {
      var id = requestAnimationFrame(function () { frames.delete(id); if (!disposed) callback(); });
      frames.add(id);
      return id;
    }
    function observe(observer, target, options) {
      observer.observe(target, options);
      disposers.push(function () { observer.disconnect(); });
    }
    sec._apdpCleanup = function () {
      if (disposed) return;
      disposed = true;
      imageRequest++;
      timers.forEach(clearTimeout);
      frames.forEach(cancelAnimationFrame);
      timers.clear(); frames.clear();
      disposers.forEach(function (dispose) { dispose(); });
      closeEnlargement();
      stopVideo();
      if (flavorModal && window.AquonPurchaseUI) window.AquonPurchaseUI.closeDialog(flavorModal);
      delete sec._apdpCleanup;
    };

    var variantsScript = sec.querySelector('[data-apdp-variants]');
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent) || []; } catch (e) {}
    }

    var mainImg = sec.querySelector('[data-apdp-main]');
    var imageStage = sec.querySelector('.apdp__main-image');
    var videoStage = sec.querySelector('[data-apdp-video-stage]');
    var zoomButton = sec.querySelector('[data-apdp-zoom-open]');
    var imageDialog = sec.querySelector('[data-apdp-image-dialog]');
    var zoomImage = sec.querySelector('[data-apdp-zoom-image]');
    var zoomToggle = sec.querySelector('[data-apdp-zoom-toggle]');
    var zoomViewport = sec.querySelector('[data-apdp-zoom-viewport]');
    var zoomStatus = sec.querySelector('[data-apdp-zoom-status]');
    var mediaStatus = sec.querySelector('[data-apdp-media-status]');
    var activeMediaType = 'image';
    var zoomRequest = 0;
    var zoomPreload = null;
    var displayedImageThumb = null;
    var imageRequest = 0;
    function stopVideo() {
      if (!videoStage) return;
      videoStage.querySelectorAll('video').forEach(function (video) {
        try {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(function (source) { source.removeAttribute('src'); });
          video.load();
        } catch (error) { /* Removing the stage still releases the player. */ }
      });
      videoStage.querySelectorAll('iframe').forEach(function (player) { player.src = 'about:blank'; });
      videoStage.replaceChildren();
    }
    function closeEnlargement() {
      zoomRequest++;
      if (zoomPreload) { zoomPreload.onload = null; zoomPreload.onerror = null; zoomPreload = null; }
      if (!imageDialog) return;
      imageDialog.hidden = true;
      imageDialog.setAttribute('aria-hidden', 'true');
      imageDialog.removeAttribute('aria-busy');
      imageDialog.classList.remove('is-full-size');
      if (window.AquonPurchaseUI) window.AquonPurchaseUI.closeDialog(imageDialog);
    }
    function openEnlargement() {
      if (disposed || activeMediaType !== 'image' || !mainImg || !imageDialog || !zoomImage || !window.AquonPurchaseUI) return;
      if (zoomButton.disabled || document.documentElement.classList.contains('aquon-purchase-dialog-open')) return;
      var visibleSrc = mainImg.currentSrc || mainImg.src;
      if (!visibleSrc) return;
      var fullSrc = mainImg.getAttribute('data-zoom-src') || visibleSrc;
      var request = ++zoomRequest;
      zoomImage.src = visibleSrc;
      zoomImage.alt = mainImg.alt || '';
      zoomImage.width = mainImg.naturalWidth || mainImg.width;
      zoomImage.height = mainImg.naturalHeight || mainImg.height;
      imageDialog.classList.remove('is-full-size');
      zoomToggle.textContent = 'View full size';
      zoomToggle.setAttribute('aria-pressed', 'false');
      zoomViewport.scrollTop = 0; zoomViewport.scrollLeft = 0;
      imageDialog.hidden = false;
      imageDialog.setAttribute('aria-hidden', 'false');
      if (zoomStatus) zoomStatus.textContent = '';
      // Preserve a useful return target on browsers that do not focus pointer-clicked buttons.
      zoomButton.focus({ preventScroll: true });
      window.AquonPurchaseUI.openDialog(imageDialog, closeEnlargement);
      if (fullSrc === visibleSrc) return;
      imageDialog.setAttribute('aria-busy', 'true');
      if (zoomStatus) zoomStatus.textContent = 'Loading full-size image';
      zoomPreload = new Image();
      zoomPreload.onload = function () {
        if (disposed || request !== zoomRequest || imageDialog.hidden) return;
        zoomImage.src = fullSrc;
        if (zoomPreload.naturalWidth && zoomPreload.naturalHeight) {
          zoomImage.width = zoomPreload.naturalWidth;
          zoomImage.height = zoomPreload.naturalHeight;
        }
        imageDialog.removeAttribute('aria-busy');
        if (zoomStatus) zoomStatus.textContent = '';
        zoomPreload = null;
      };
      zoomPreload.onerror = function () {
        if (disposed || request !== zoomRequest || imageDialog.hidden) return;
        imageDialog.removeAttribute('aria-busy');
        if (zoomStatus) zoomStatus.textContent = 'Full-size image could not be loaded. Showing the current image.';
        zoomPreload = null;
      };
      zoomPreload.src = fullSrc;
    }
    if (zoomButton && mainImg && imageDialog && window.AquonPurchaseUI) {
      zoomButton.hidden = false;
      zoomButton.addEventListener('click', openEnlargement);
      sec.querySelectorAll('[data-apdp-zoom-close]').forEach(function (button) { button.addEventListener('click', closeEnlargement); });
      zoomToggle.addEventListener('click', function () {
        var full = imageDialog.classList.toggle('is-full-size');
        zoomToggle.setAttribute('aria-pressed', full ? 'true' : 'false');
        zoomToggle.textContent = full ? 'Fit image' : 'View full size';
        zoomViewport.scrollTop = 0; zoomViewport.scrollLeft = 0;
      });
    }
    function showImage(src, alt, fullSrc, thumb) {
      if (!mainImg || !src) return;
      closeEnlargement();
      stopVideo();
      activeMediaType = 'image';
      if (videoStage) videoStage.hidden = true;
      if (imageStage) { imageStage.hidden = false; imageStage.setAttribute('aria-busy', 'true'); }
      if (galleryEl) galleryEl.classList.remove('is-video');
      if (zoomButton) { zoomButton.hidden = !window.AquonPurchaseUI; zoomButton.disabled = true; }
      if (mediaStatus) mediaStatus.textContent = '';
      var request = ++imageRequest;
      var image = new Image();
      image.onload = function () {
        if (disposed || request !== imageRequest || activeMediaType !== 'image') return;
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        if (image.naturalWidth && image.naturalHeight) {
          mainImg.width = image.naturalWidth;
          mainImg.height = image.naturalHeight;
        }
        if (alt != null) mainImg.alt = alt;
        mainImg.setAttribute('data-zoom-src', fullSrc || src);
        displayedImageThumb = thumb || null;
        selectMediaThumb(displayedImageThumb);
        mainImg.classList.remove('is-fading');
        if (imageStage) imageStage.removeAttribute('aria-busy');
        if (zoomButton) zoomButton.disabled = false;
      };
      image.onerror = function () {
        if (disposed || request !== imageRequest || activeMediaType !== 'image') return;
        mainImg.classList.remove('is-fading');
        if (imageStage) imageStage.removeAttribute('aria-busy');
        if (zoomButton) zoomButton.disabled = false;
        selectMediaThumb(displayedImageThumb);
        if (mediaStatus) mediaStatus.textContent = 'Image could not be loaded. The previous image is still shown.';
      };
      image.src = src;
    }
    var priceEl = sec.querySelector('[data-apdp-price]');
    var compareEl = sec.querySelector('[data-apdp-compare]');
    var cta = sec.querySelector('[data-apdp-atc]');
    var toast = sec.querySelector('[data-apdp-toast]');
    var toastTimer = null;

    // Track option selections by index
    var optionGroups = sec.querySelectorAll('[data-apdp-option-group]');
    var selectedOptions = {};
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var activeBtn = group.querySelector('.is-active[data-value]');
      if (activeBtn) selectedOptions[idx] = activeBtn.getAttribute('data-value');
    });
    // Sync price/image to the active pill on init (in case merchant hid the default pack)
    later(function () {
      var v0 = findMatchingVariant();
      if (v0) updateFromVariant(v0, true);
      if (selectedBundle) updateCtaLabel(Number(selectedBundle.getAttribute('data-quantity')));
    }, 0);

    function findMatchingVariant() {
      if (!variants.length) return null;
      return variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (idxKey) {
          var idx = parseInt(idxKey, 10);
          return v.options[idx] === selectedOptions[idxKey];
        });
      }) || null;
    }

    function updateFromVariant(v, preserveInitialImage) {
      if (!v) return;
      if (cta) {
        cta.setAttribute('data-variant-id', v.id);
        cta.disabled = !v.available;
        var span = cta.querySelector('.apdp__cta-text');
        if (span) span.textContent = v.available ? (cta.dataset.originalLabel || span.textContent) : 'Sold out';
      }
      if (priceEl) priceEl.textContent = moneyFormat(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = moneyFormat(v.compare_at_price);
        } else {
          compareEl.textContent = '';
        }
      }
      // Variant hydration must not replace the selected bundle's savings.
      var offer = selectedBundle && window.AquonPurchase.tierFor(selectedBundle.getAttribute('data-bundle-variant'));
      updateDiscountBadge(offer || { cents: v.price, compareCents: v.compare_at_price });
      if (!preserveInitialImage && mainImg && v.featured_image && v.featured_image.src) {
        mainImg.classList.remove('is-cover');
        showImage(v.featured_image.src, v.featured_image.alt);
      }
      if (preserveInitialImage) selectMediaThumb(activeMediaType === 'image' ? displayedImageThumb : sec.querySelector('[data-apdp-thumb].is-active'));
    }

    // Option button clicks
    sec.querySelectorAll('[data-apdp-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-apdp-option'), 10);
        var val = btn.getAttribute('data-value');
        selectedOptions[idx] = val;

        // Toggle active class in the same group
        var group = btn.closest('[data-apdp-option-group]');
        if (group) {
          group.querySelectorAll('[data-apdp-option]').forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');
          var valueLabel = sec.querySelector('[data-apdp-option-value="' + idx + '"]');
          if (valueLabel) valueLabel.textContent = val;
        }

        // If a flavor button carries its own image, update immediately
        var overrideSrc = btn.getAttribute('data-image-src');
        if (overrideSrc && mainImg) {
          mainImg.classList.remove('is-cover');
          showImage(overrideSrc);
        }

        var v = findMatchingVariant();
        if (v) updateFromVariant(v);
      });
    });

    // Flavour product links keep the chosen bundle across real product navigation.
    var titleEl = sec.querySelector('[data-apdp-title]');
    var descEl = sec.querySelector('[data-apdp-desc]');
    var flavorValueEl = sec.querySelector('[data-apdp-flavor-value]');
    var thumbsEl = sec.querySelector('.apdp__thumbs');

    function normalizeImg(url, size) {
      if (!url) return '';
      if (url.indexOf('//') === 0) url = window.location.protocol + url;
      if (size) url = url.replace(/(_\d+x\d*|_\d+x)(?=\.(jpg|jpeg|png|webp))/i, '_' + size);
      return url;
    }

    // Swap the bundle-card images to the given flavour's per-pack images. The URLs
    // travel on each flavour tile as data-bundle-img-1/2/3 (from the flavour
    // variant's metafields), so this needs no network request. Each card carries
    // data-pack (1/2/3) to pick its matching image. We preload then swap so there
    // is no flash, and the card image box keeps fixed dimensions (no layout shift).
    // If a flavour has no bundle metafields, its cards keep the static image.
    function updateBundleImages(flavorEl) {
      if (!flavorEl) return;
      var byPack = {
        '1': flavorEl.getAttribute('data-bundle-img-1'),
        '2': flavorEl.getAttribute('data-bundle-img-2'),
        '3': flavorEl.getAttribute('data-bundle-img-3')
      };
      sec.querySelectorAll('[data-apdp-bundle-img]').forEach(function (img) {
        var url = byPack[img.getAttribute('data-pack') || '1'];
        if (!url || img.getAttribute('src') === url) return;
        var pre = new Image();
        pre.onload = function () { if (!disposed) { img.src = url; img.removeAttribute('srcset'); } };
        pre.src = url;
      });
    }

    function rebuildThumbs(prod) {
      if (!thumbsEl) return;
      var imgs = prod.images || [];
      if (!imgs.length) return;
      thumbsEl.innerHTML = '';
      imgs.forEach(function (raw, i) {
        var full = normalizeImg(raw, '1200x');
        var small = normalizeImg(raw, '200x');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'apdp__thumb' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('data-apdp-thumb', '');
        btn.setAttribute('data-index', String(i));
        btn.setAttribute('data-image-src', full);
        btn.setAttribute('aria-label', 'Show image ' + (i + 1));
        var img = document.createElement('img');
        img.className = 'apdp__thumb-img';
        img.loading = 'lazy';
        img.src = small;
        img.alt = '';
        btn.appendChild(img);
        btn.addEventListener('click', function () {
          thumbsEl.querySelectorAll('[data-apdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (!mainImg) return;
          mainImg.classList.toggle('is-cover', i > 0);
          var b = sec.querySelector('[data-apdp-badge]');
          if (b) b.hidden = i > 0 || !b.textContent.trim();
          if (galleryEl) galleryEl.classList.toggle('is-first-image', i === 0);
          mainImg.classList.add('is-fading');
          later(function () {
            mainImg.src = full;
            mainImg.srcset = '';
            mainImg.classList.remove('is-fading');
          }, 150);
        });
        thumbsEl.appendChild(btn);
      });
      // Re-collapse the fresh thumbs behind the +/- toggle (desktop).
      if (thumbsEl._apdpApplyExpand) thumbsEl._apdpApplyExpand();
    }

    sec.querySelectorAll('[data-apdp-flavor]').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var url = tile.getAttribute('data-flavor-url') || tile.getAttribute('href');
        if (!url) return;
        e.preventDefault();
        var destination = new URL(url, window.location.origin);
        var tier = selectedBundle && selectedBundle.getAttribute('data-bundle-variant');
        if (tier) destination.searchParams.set('bundle', tier);
        window.location.assign(destination.href);
      });
    });

    // On load, sync the bundle cards to the active flavour (covers the home /
    // bundle contexts where the section product may differ from the first tile).
    updateBundleImages(sec.querySelector('[data-apdp-flavor].is-active') || sec.querySelector('[data-apdp-flavor]'));

    // All gallery controls share the same media activation path.
    var galleryEl = sec.querySelector('.apdp__gallery');
    function setBadgeForIndex(index) {
      var b = sec.querySelector('[data-apdp-badge]');
      if (!b) return;
      b.hidden = index > 0 || !b.textContent.trim();
    }
    function setGalleryPaddingForIndex(index) {
      if (galleryEl) galleryEl.classList.toggle('is-first-image', index === 0);
    }
    function selectMediaThumb(thumb) {
      sec.querySelectorAll('[data-apdp-thumb]').forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
        item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
      });
      var index = thumb ? Array.prototype.indexOf.call(sec.querySelectorAll('[data-apdp-thumb]'), thumb) : 0;
      setBadgeForIndex(activeMediaType === 'image' ? index : 1);
      setGalleryPaddingForIndex(activeMediaType === 'image' ? index : 1);
    }
    function activateMedia(thumb) {
      if (disposed) return;
      var type = thumb.getAttribute('data-media-type') || 'image';
      if (type === 'video' || type === 'external_video') {
        var template = document.getElementById(thumb.getAttribute('data-video-template'));
        if (!videoStage || !template || !template.content) return;
        imageRequest++;
        closeEnlargement();
        stopVideo();
        activeMediaType = type;
        if (imageStage) { imageStage.hidden = true; imageStage.removeAttribute('aria-busy'); }
        if (zoomButton) zoomButton.hidden = true;
        videoStage.replaceChildren(template.content.cloneNode(true));
        videoStage.hidden = false;
        if (galleryEl) galleryEl.classList.add('is-video');
        if (mediaStatus) mediaStatus.textContent = '';
        selectMediaThumb(thumb);
        return;
      }
      var src = thumb.getAttribute('data-image-src');
      if (!src || !mainImg) return;
      showImage(src, thumb.getAttribute('data-image-alt'), thumb.getAttribute('data-zoom-src'), thumb);
      mainImg.classList.toggle('is-cover', Number(thumb.getAttribute('data-index')) > 0);
      selectMediaThumb(thumb);
    }
    sec.querySelectorAll('[data-apdp-thumb]').forEach(function (thumb) {
      if (!displayedImageThumb && mainImg && mainImg.getAttribute('data-image-id') && thumb.getAttribute('data-image-id') === mainImg.getAttribute('data-image-id')) displayedImageThumb = thumb;
      thumb.addEventListener('click', function () { activateMedia(thumb); });
    });
    // Match the Liquid-rendered image without replacing the merchant's override.
    selectMediaThumb(displayedImageThumb);

    // Collapse the thumbnail column to the first N + a +/- toggle (desktop).
    var cleanupThumbs = setupThumbExpand(sec);
    if (cleanupThumbs) disposers.push(cleanupThumbs);

    // Gallery prev/next arrows (reuse the thumbnail switching; requery each time
    // so it stays correct after flavor-driven thumb rebuilds).
    var galPrev = sec.querySelector('[data-apdp-gallery-prev]');
    var galNext = sec.querySelector('[data-apdp-gallery-next]');
    function galThumbs() { return Array.prototype.slice.call(sec.querySelectorAll('[data-apdp-thumb]')); }
    function galNav(dir) {
      var thumbs = galThumbs();
      if (thumbs.length < 2) return;
      var active = -1;
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) { active = i; break; } }
      var targetIndex = active < 0 ? (dir > 0 ? 0 : thumbs.length - 1) : (active + dir + thumbs.length) % thumbs.length;
      var target = thumbs[targetIndex];
      // If we land on a thumb hidden behind the collapsed gallery, expand first
      // so the newly-active thumbnail is actually visible.
      if (target.classList.contains('apdp__thumb--overflow')) {
        var tgl = sec.querySelector('[data-apdp-thumb-toggle]');
        if (tgl && tgl.getAttribute('aria-expanded') === 'false') tgl.click();
      }
      target.click();
      if (thumbsEl && thumbsEl.classList.contains('is-collapsible')) {
        target.scrollIntoView({ block: 'nearest' });
      }
    }
    function galUpdateNav() {
      var n = galThumbs().length;
      if (galPrev) galPrev.hidden = n < 2;
      if (galNext) galNext.hidden = n < 2;
    }
    if (galPrev) galPrev.addEventListener('click', function () { galNav(-1); });
    if (galNext) galNext.addEventListener('click', function () { galNav(1); });
    galUpdateNav();
    if (thumbsEl) thumbsEl.addEventListener('keydown', function (event) {
      var thumbs = galThumbs();
      var index = thumbs.indexOf(event.target);
      if (index < 0) return;
      var target;
      if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = thumbs.length - 1;
      else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = (index + 1) % thumbs.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = (index - 1 + thumbs.length) % thumbs.length;
      else return;
      event.preventDefault();
      var toggle = thumbsEl.querySelector('[data-apdp-thumb-toggle]');
      if (thumbs[target].classList.contains('apdp__thumb--overflow') && toggle && toggle.getAttribute('aria-expanded') === 'false') toggle.click();
      thumbs[target].click();
      thumbs[target].focus({ preventScroll: true });
      thumbs[target].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    if (thumbsEl && window.MutationObserver) {
      observe(new MutationObserver(galUpdateNav), thumbsEl, { childList: true });
    }

    // Touch swipe on the gallery (mobile) - drag left = next, right = prev.
    // Replaces the arrows that are hidden on phones; reuses galNav().
    var galArea = sec.querySelector('.apdp__main-image') || mainImg;
    if (galArea) {
      var swStartX = 0, swStartY = 0, swActive = false;
      galArea.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { swActive = false; return; }
        swStartX = e.touches[0].clientX;
        swStartY = e.touches[0].clientY;
        swActive = true;
      }, { passive: true });
      galArea.addEventListener('touchend', function (e) {
        if (!swActive) return;
        swActive = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - swStartX;
        var dy = t.clientY - swStartY;
        // Horizontal-dominant swipe only, so vertical page scroll is unaffected.
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          galNav(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    // Bundle selection
    var selectedBundle = null;
    var flavorSelectionsByTier = Object.create(null);
    var lastFlavorTier = null;
    var busy = false;
    var bundleValueLabel = sec.querySelector('[data-apdp-bundle-value]');
    var freebieEls = sec.querySelectorAll('[data-apdp-freebie]');

    function updateFreebies(bundleIndex, bundleQuantity) {
      // Which gift tiles light up is driven entirely by each freebie's
      // `unlock_for` list. Note the 3-pack's free Pack of 24 is NOT a gift line:
      // it is the 4th flavour pick on the bundle line, so the 3-pack only adds
      // the bottle here.
      freebieEls.forEach(function (f) {
        var raw = f.getAttribute('data-unlock-for') || '';
        var list = raw.split(',').map(function (s) { return parseInt(s.trim(), 10); });
        var included = list.indexOf(bundleIndex) !== -1;
        f.classList.toggle('is-disabled', !included);
        // Text state beside the dimming, so eligibility never relies on opacity alone:
        // 'Included with this pack', or the pack(s) that include this gift.
        var includedNote = f.querySelector('[data-apdp-freebie-included]');
        var excludedNote = f.querySelector('[data-apdp-freebie-excluded]');
        if (includedNote) includedNote.hidden = !included;
        if (excludedNote) excludedNote.hidden = included;
      });
    }

    var defaultBundleIndex = 0;
    var defaultBundleQuantity = 0;
    sec.querySelectorAll('[data-apdp-bundle]').forEach(function (bundle, i) {
      var qty = parseInt(bundle.getAttribute('data-quantity'), 10) || 0;
      if (i === 0 || bundle.classList.contains('is-selected')) {
        selectedBundle = bundle;
        defaultBundleIndex = i + 1;
        defaultBundleQuantity = qty;
      }
      var tier = window.AquonPurchase.tierFor(bundle.getAttribute('data-bundle-variant'));
      bundle.setAttribute('aria-disabled', tier && tier.available === false ? 'true' : 'false');
      if (tier && tier.cents != null) {
        var priceNode = bundle.querySelector('.apdp__bundle-price');
        if (priceNode) priceNode.textContent = tier.price;
        var unit = bundle.querySelector('.apdp__bundle-per');
        if (unit) unit.textContent = tier.unit + ' per sachet · ' + (tier.picks * 24) + ' sachets';
        // Live compare price and saving (store money format, shared rounding convention).
        // Only when the shared helper supplied them; otherwise the rendered text stays.
        if (typeof tier.compareText === 'string') {
          var oldNode = bundle.querySelector('.apdp__bundle-price-old');
          var oldLabel = bundle.querySelector('[data-apdp-regular-label]');
          if (oldNode) { oldNode.textContent = tier.compareText; oldNode.hidden = !tier.compareText; }
          if (oldLabel) oldLabel.hidden = !tier.compareText;
          var saving = bundle.querySelector('.apdp__bundle-discount');
          if (saving && typeof tier.percentLabel === 'string') { saving.textContent = tier.percentLabel; saving.hidden = !tier.percentLabel; }
        }
      }
      bundle.addEventListener('click', function () {
        if (busy || bundle.getAttribute('aria-disabled') === 'true') return;
        sec.querySelectorAll('[data-apdp-bundle]').forEach(function (b) { b.classList.remove('is-selected'); });
        bundle.classList.add('is-selected');
        selectedBundle = bundle;
        if (bundleValueLabel) bundleValueLabel.textContent = bundle.getAttribute('data-name') || '';
        updateFreebies(i + 1, qty);
        updateCtaLabel(qty);
      });
    });
    if (window.AquonPurchaseUI) {
      window.AquonPurchaseUI.radioGroup(sec.querySelector('.apdp__bundles'), '[data-apdp-bundle]', 'is-selected');
      optionGroups.forEach(function (group) {
        window.AquonPurchaseUI.radioGroup(group.querySelector('[role="radiogroup"]'), '[data-apdp-option]', 'is-active');
      });
    }
    if (defaultBundleIndex > 0) updateFreebies(defaultBundleIndex, defaultBundleQuantity);
    // The free-box tile's contents line follows the flavour-pack tier's shared contents
    // field (tier.contents, e.g. '72 + 24 free = 96 sachets'); the Liquid text is the fallback.
    freebieEls.forEach(function (f) {
      var contentsEl = f.querySelector('[data-apdp-freebie-contents]');
      if (!contentsEl) return;
      var bundleCards = sec.querySelectorAll('[data-apdp-bundle]');
      (f.getAttribute('data-unlock-for') || '').split(',').forEach(function (s) {
        var card = bundleCards[parseInt(s.trim(), 10) - 1];
        var tier = card && window.AquonPurchase.tierFor(card.getAttribute('data-bundle-variant'));
        if (tier && tier.flavorPack && typeof tier.contents === 'string' && tier.contents) contentsEl.textContent = tier.contents;
      });
    });

    function updateDiscountBadge(tier) {
      var badge = sec.querySelector('[data-apdp-badge]');
      if (!badge) return;
      var cents = Number(tier && tier.cents);
      var compare = Number(tier && tier.compareCents);
      var valid = Number.isFinite(cents) && cents >= 0 && Number.isFinite(compare) && compare > cents;
      var text = '';
      // Same label and rounding convention as the Liquid badge (snippets/aquon-savings.liquid).
      if (valid && window.AquonOffer && typeof window.AquonOffer.label === 'function') text = window.AquonOffer.label(cents, compare);
      else if (valid) {
        var percentage = Math.round((compare - cents) / compare * 100);
        text = percentage > 0 ? percentage + '% OFF' : '';
      }
      badge.textContent = text;
      badge.hidden = !text || activeMediaType !== 'image' ||
        !!(displayedImageThumb && Number(displayedImageThumb.getAttribute('data-index')) > 0);
    }

    // Every tier starts with an explicit flavour selection.
    function checkoutText(key, fallback) {
      var strings = window.AquonCheckoutConfig && window.AquonCheckoutConfig.strings;
      return strings && strings[key] || fallback;
    }
    function updateCtaLabel(quantity) {
      if (!cta) return;
      var label = cta.querySelector('.apdp__cta-text');
      if (!label) return;
      var tier = selectedBundle && window.AquonPurchase.tierFor(selectedBundle.getAttribute('data-bundle-variant'));
      cta.disabled = !!(tier && tier.available === false);
      label.textContent = cta.disabled ? checkoutText('pack_unavailable', 'Pack unavailable') : checkoutText('choose_flavours', 'Choose flavours');
      var summary = sec.querySelector('[data-apdp-pack-summary]');
      if (summary && tier) {
        summary.replaceChildren();
        var total = document.createElement('strong');
        // tier.contents / tier.extras (shared config) spell out the free box and gift,
        // e.g. '72 + 24 free = 96 sachets' and 'Plus a free AQUON glass bottle'.
        total.textContent = (tier.contents || ((tier.picks * 24) + ' sachets')) + ' · ' + tier.price;
        var gifts = document.createElement('span');
        gifts.textContent = tier.extras || (tier.gift + ' included');
        summary.append(total, gifts);
      }
      if (tier && priceEl) priceEl.textContent = tier.price;
      if (tier && compareEl) compareEl.textContent = tier.compareCents > tier.cents ? moneyFormat(tier.compareCents) : '';
      if (tier) updateDiscountBadge(tier);
    }
    var requestedBundle = new URLSearchParams(window.location.search).get('bundle');
    if (requestedBundle) {
      var requestedCard = Array.from(sec.querySelectorAll('[data-apdp-bundle]')).find(function (b) { return b.getAttribute('data-bundle-variant') === requestedBundle; });
      if (requestedCard) requestedCard.click();
    }
    updateCtaLabel(selectedBundle ? Number(selectedBundle.getAttribute('data-quantity')) : defaultBundleQuantity);

    // Confirmation state after a successful add. The sticky bar mirrors this
    // button's label and classes, so both surfaces confirm at once - which is
    // the only feedback now that the quick cart no longer opens for sticky adds.
    // Reverts to the CURRENT tier's label, not the one cached at page load, so
    // switching pack mid-flow can't restore the wrong wording.
    var addedTimer = null;
    function showAdded() {
      if (!cta) return;
      var label = cta.querySelector('.apdp__cta-text');
      if (label) label.textContent = checkoutText('added', 'Pack added');
      cta.classList.add('is-added');
      cancelLater(addedTimer);
      addedTimer = later(function () {
        cta.classList.remove('is-added');
        var q = selectedBundle ? (parseInt(selectedBundle.getAttribute('data-quantity'), 10) || 1) : 1;
        updateCtaLabel(q);
      }, 2000);
    }

    // Show toast
    function showToast(msg, isError, cartRecovery) {
      var error = sec.querySelector('[data-apdp-purchase-error]');
      if (error) {
        error.textContent = isError ? msg : '';
        error.hidden = !isError;
        if (isError && cartRecovery) {
          var recovery = document.createElement('a');
          recovery.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
          recovery.textContent = checkoutText('view_cart', 'View cart');
          error.appendChild(document.createTextNode(' '));
          error.appendChild(recovery);
        }
      }
      if (!toast) return;
      var cartLink = toast.querySelector('.apdp__toast-link');
      if (cartLink) cartLink.hidden = !!isError && !cartRecovery;
      toast.querySelector('.apdp__toast-text').textContent = msg;
      toast.classList.toggle('is-error', !!isError);
      toast.hidden = false;
      frame(function () { toast.classList.add('is-visible'); });
      cancelLater(toastTimer);
      toastTimer = later(function () {
        toast.classList.remove('is-visible');
        later(function () { toast.hidden = true; }, 300);
      }, 3200);
    }

    // Flavour picker popup (opens on Add to cart when enabled)
    var flavorModal = sec.querySelector('[data-apdp-flavor-modal]');

    // Which control started the current add-to-cart flow. The sticky bar proxies
    // the main CTA, so the main handler records where the click really came from
    // and the success path uses it: adds started from the sticky bar refresh the
    // cart in place and keep the customer on the PDP, everything else opens the
    // quick cart exactly as before. `flavorFlowOrigin` carries the same answer
    // across the flavour modal, which sits between the click and the add.
    var addOrigin = 'main';
    // Retain a confirmed add only when checkout fails, so Retry never adds it twice.
    var checkoutRetryItems = null;

    // Post-add behaviour, shared by the direct and flavour-modal paths.
    function afterAdd(origin, button) {
      if (origin === 'checkout') return window.AquonPurchase.checkout({ trigger: button, returnFocus: cta });
      if (origin === 'cart') { window.location.assign((window.Shopify.routes.root || '/') + 'cart'); return; }
      if (window.AquonCart) window.AquonCart.open();
      showToast('Your pack and included gifts are in the cart', false);
    }
    sec.addEventListener('aquon:purchase', function (event) {
      if (busy || cta.disabled) return;
      addOrigin = event.detail && event.detail.destination || 'main';
      cta.click();
    });
    async function purchase(picks, button, origin) {
      if (busy) return;
      var items;
      try { items = window.AquonPurchase.build(bundleVariantFor(selectedBundle), picks); }
      catch (error) { showToast(error.message, true); return; }
      var itemKey = JSON.stringify(items);
      var alreadyAdded = origin === 'checkout' && checkoutRetryItems === itemKey;
      var handoffComplete = false;
      var buttonLabel = button.querySelector('[data-aquon-checkout-label]');
      var mainLabel = cta.querySelector('.apdp__cta-text');
      var progress = sec.querySelector('[data-aquon-purchase-status]');
      var errorNode = sec.querySelector('[data-apdp-purchase-error]');
      if (errorNode) { errorNode.textContent = ''; errorNode.hidden = true; }
      function phase(message) {
        if (buttonLabel) buttonLabel.textContent = message;
        if (mainLabel) mainLabel.textContent = message;
        if (progress) progress.textContent = message;
      }
      busy = true;
      cancelLater(addedTimer);
      cta.classList.remove('is-added');
      cta.classList.add('is-loading');
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      cta.disabled = true;
      cta.setAttribute('aria-busy', 'true');
      if (flavorModal) flavorModal.querySelectorAll('button[data-apdp-flavor-close]').forEach(function (control) { control.disabled = true; });
      updateFlavorCount();
      phase(alreadyAdded ? checkoutText('opening', 'Opening checkout…') : checkoutText('adding_pack', 'Adding your pack…'));
      try {
        if (!alreadyAdded) {
          await window.AquonPurchase.add(items);
          if (origin === 'checkout') checkoutRetryItems = itemKey;
        }
        if (disposed) return;
        if (origin === 'checkout') phase(checkoutText('opening', 'Opening checkout…'));
        // Release the chooser's inert background and scroll lock before the SDK opens.
        closeFlavorModal(true);
        await afterAdd(origin, button);
        checkoutRetryItems = null;
        handoffComplete = true;
      } catch (error) {
        if (disposed) return;
        var needsCheckoutRetry = origin === 'checkout' && checkoutRetryItems === itemKey;
        if (!(error && error.checkoutHandled)) {
          if (needsCheckoutRetry && flavorModal && flavorModal.hidden) openFlavorModal();
          showToast(needsCheckoutRetry ? checkoutText('checkout_retry', 'Your pack is in your cart. Try checkout again, or view your cart.') : ((error && error.message) || checkoutText('add_error', 'Unable to add your pack. Please try again.')), true, needsCheckoutRetry);
        }
      } finally {
        if (disposed) return;
        busy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        cta.removeAttribute('aria-busy');
        var currentTier = window.AquonPurchase.tierFor(bundleVariantFor(selectedBundle));
        cta.disabled = !!(currentTier && currentTier.available === false);
        button.classList.remove('is-loading');
        cta.classList.remove('is-loading');
        if (buttonLabel) buttonLabel.textContent = checkoutText('continue', 'Continue to checkout');
        if (progress) progress.textContent = '';
        if (flavorModal) flavorModal.querySelectorAll('button[data-apdp-flavor-close]').forEach(function (control) { control.disabled = false; });
        updateCtaLabel(selectedBundle ? Number(selectedBundle.getAttribute('data-quantity')) : 1);
        updateFlavorCount();
        if (handoffComplete) showAdded();
        // A failed add keeps the dialog open; its button lost focus while it was disabled,
        // so give it back instead of leaving focus on <body>.
        if (flavorModal && !flavorModal.hidden && !button.disabled) {
          var current = document.activeElement;
          if (!current || current === document.body || !flavorModal.contains(current)) button.focus({ preventScroll: true });
        }
      }
    }

    // How many flavours this tier asks the buyer to pick. Falls back to the
    // tier's cart quantity for bundles configured the old way.
    function flavorPicksFor(bundle) {
      if (!bundle) return 1;
      var picks = parseInt(bundle.getAttribute('data-flavor-picks'), 10);
      if (!isNaN(picks) && picks > 0) return picks;
      return parseInt(bundle.getAttribute('data-quantity'), 10) || 1;
    }

    // Variant id of the pre-priced bundle product for this tier (₹999 / ₹1,799 /
    // ₹2,499). When present the cart gets ONE line at that price and the flavours
    // travel as line-item properties, so no discount has to fire.
    function bundleVariantFor(bundle) {
      if (!bundle) return 0;
      return parseInt(bundle.getAttribute('data-bundle-variant'), 10) || 0;
    }

    // The flavour currently selected on the page. The active tile is switched
    // synchronously on click (before the product fetch resolves), so it is the
    // most reliable source; the CTA attribute is only a fallback for contexts
    // that render no flavour row.
    function currentFlavorName() {
      var active = sec.querySelector('[data-apdp-flavor].is-active');
      var fromTile = active && active.getAttribute('data-flavor-name');
      return fromTile || cta.getAttribute('data-product-title') || 'Flavour';
    }

    function openFlavorModal() {
      if (!flavorModal) return false;
      // Sync required total to the selected bundle's flavour-pick count. This is
      // NOT the same as data-quantity: the 3-pack is 3 paid packs + 1 free, so
      // the buyer picks 4 flavours while the tier's quantity is 3.
      var submit = flavorModal.querySelector('[data-apdp-flavor-submit]');
      var target = flavorModal.querySelector('[data-apdp-flavor-target]');
      var picks = flavorPicksFor(selectedBundle);
      if (submit && picks > 0) submit.setAttribute('data-total', picks);
      if (target && picks > 0) target.textContent = picks;
      flavorModal.hidden = false;
      flavorModal.setAttribute('aria-hidden', 'false');
      // The CTA is the fallback focus target when the control that opened the chooser (the
      // sticky bar's button, which mirrors the busy CTA during an add) cannot take focus back.
      if (window.AquonPurchaseUI) window.AquonPurchaseUI.openDialog(flavorModal, closeFlavorModal, cta);
      var error = flavorModal.querySelector('[data-apdp-purchase-error]');
      if (error) { error.hidden = true; error.textContent = ''; }
      var progress = flavorModal.querySelector('[data-aquon-purchase-status]');
      if (progress) progress.textContent = '';
      // Keep a separate selection for each tier, including deliberate empties.
      // A first visit to another tier inherits only what fits; the original
      // tier's complete selection stays available when the shopper returns.
      var tierKey = String(bundleVariantFor(selectedBundle));
      var saved = flavorSelectionsByTier[tierKey];
      if (!saved && lastFlavorTier !== null) saved = flavorSelectionsByTier[lastFlavorTier];
      var remaining = picks;
      flavorModal.querySelectorAll('[data-apdp-flavor-card]').forEach(function (card) {
        var q = card.querySelector('[data-apdp-flavor-qty]');
        var requested = saved ? Number(saved[card.getAttribute('data-variant-id')]) || 0
          : (card.getAttribute('data-is-current') === 'true' ? 1 : 0);
        var quantity = card.getAttribute('data-available') === 'false' ? 0
          : Math.min(Math.max(0, Math.floor(requested)), remaining);
        if (q) q.textContent = String(quantity);
        card.classList.toggle('is-selected', quantity > 0);
        remaining -= quantity;
      });
      lastFlavorTier = tierKey;
      announceFlavor('');
      updateFlavorCount();
      return true;
    }
    function closeFlavorModal(force) {
      if (busy && force !== true) return;
      if (!flavorModal) return;
      flavorModal.hidden = true;
      flavorModal.setAttribute('aria-hidden', 'true');
      if (window.AquonPurchaseUI) window.AquonPurchaseUI.closeDialog(flavorModal);
    }
    function flavorRequired() {
      var submit = flavorModal && flavorModal.querySelector('[data-apdp-flavor-submit]');
      return submit ? parseInt(submit.getAttribute('data-total'), 10) || 3 : 3;
    }
    function flavorTotal() {
      var total = 0;
      if (flavorModal) flavorModal.querySelectorAll('[data-apdp-flavor-qty]').forEach(function (q) { total += parseInt(q.textContent, 10) || 0; });
      return total;
    }
    // Pack of 1 '+' buttons act as single-choice toggles (aria-pressed plus a 'Choose …'
    // label); multi-pack tiers restore the rendered 'Add one …' label.
    var flavorAddLabels = new Map();
    function syncChoiceButton(inc, single, chosen) {
      if (!flavorAddLabels.has(inc)) flavorAddLabels.set(inc, inc.getAttribute('aria-label'));
      var addLabel = flavorAddLabels.get(inc);
      var chooseLabel = inc.getAttribute('data-choose-label');
      if (single) {
        inc.setAttribute('aria-pressed', chosen ? 'true' : 'false');
        if (chooseLabel) inc.setAttribute('aria-label', chooseLabel);
      } else {
        inc.removeAttribute('aria-pressed');
        if (addLabel !== null) inc.setAttribute('aria-label', addLabel);
      }
    }
    // Polite announcement, cleared first so a repeated message is read again; an empty
    // text only clears a message that no longer applies.
    var flavorStatusFrame = 0;
    function announceFlavor(text) {
      var region = flavorModal && flavorModal.querySelector('[data-apdp-flavor-status]');
      if (!region) return;
      region.textContent = '';
      if (flavorStatusFrame) { cancelFrame(flavorStatusFrame); flavorStatusFrame = 0; }
      if (text) flavorStatusFrame = frame(function () { flavorStatusFrame = 0; region.textContent = text; });
    }
    function flavorHintText() {
      var hint = flavorModal && flavorModal.querySelector('[data-apdp-flavor-hint]');
      return hint ? hint.textContent.trim() : '';
    }
    // A step button that has just become disabled must not drop focus to <body>: move it
    // to the same card's other step button, then Buy it now, then the dialog heading.
    function keepFlavorFocus(btn, card) {
      if (!btn || !btn.disabled || !flavorModal || flavorModal.hidden) return;
      var current = document.activeElement;
      if (current && current !== btn && current !== document.body && flavorModal.contains(current)) return;
      var other = card.querySelector(btn.hasAttribute('data-apdp-flavor-inc') ? '[data-apdp-flavor-dec]' : '[data-apdp-flavor-inc]');
      var submit = flavorModal.querySelector('[data-apdp-flavor-submit]');
      var target = [other, submit].filter(function (b) { return b && !b.disabled; })[0];
      if (!target) {
        target = flavorModal.querySelector('.apdp-flavor-modal__title');
        if (target) target.setAttribute('tabindex', '-1');
      }
      if (target) target.focus({ preventScroll: true });
    }
    function updateFlavorCount() {
      if (!flavorModal) return;
      var total = 0;
      flavorModal.querySelectorAll('[data-apdp-flavor-qty]').forEach(function (q) {
        total += parseInt(q.textContent, 10) || 0;
      });
      var countEl = flavorModal.querySelector('[data-apdp-flavor-count]');
      if (countEl) countEl.textContent = total;
      var submit = flavorModal.querySelector('[data-apdp-flavor-submit]');
      var required = flavorRequired();
      // A capacity-1 tier (Pack of 1) is a single choice: '+' on another flavour replaces
      // the chosen one, so '+' stays enabled there (the chosen flavour's '+' is a no-op).
      // Multi-pack tiers keep the stepper rule: '+' is disabled once the pack is full,
      // and a visible hint says how to swap.
      var single = required === 1;
      var full = !single && total >= required;
      flavorModal.setAttribute('data-apdp-single', single ? 'true' : 'false');
      flavorModal.querySelectorAll('[data-apdp-flavor-card]').forEach(function (card) {
        var quantity = Number(card.querySelector('[data-apdp-flavor-qty]').textContent) || 0;
        var unavailable = card.getAttribute('data-available') === 'false';
        var inc = card.querySelector('[data-apdp-flavor-inc]');
        inc.disabled = busy || full || unavailable;
        card.querySelector('[data-apdp-flavor-dec]').disabled = busy || quantity === 0;
        card.classList.toggle('is-selected', quantity > 0);
        syncChoiceButton(inc, single, quantity > 0);
        var unavailableNote = card.querySelector('[data-apdp-flavor-unavailable]');
        if (unavailableNote) unavailableNote.hidden = !unavailable;
      });
      var hint = flavorModal.querySelector('[data-apdp-flavor-hint]');
      if (hint) hint.hidden = !full;
      var offer = window.AquonPurchase.tierFor(bundleVariantFor(selectedBundle));
      if (submit) submit.disabled = busy || total !== required || !offer || offer.available === false;
      if (lastFlavorTier !== null) {
        var saved = Object.create(null);
        flavorModal.querySelectorAll('[data-apdp-flavor-card]').forEach(function (card) {
          saved[card.getAttribute('data-variant-id')] = Number(card.querySelector('[data-apdp-flavor-qty]').textContent) || 0;
        });
        flavorSelectionsByTier[lastFlavorTier] = saved;
      }
      window.AquonPurchase.selectionSummary(flavorModal.querySelector('[data-aquon-selection-summary]'), window.AquonPurchase.tierFor(bundleVariantFor(selectedBundle)), total);
    }
    if (flavorModal) {
      flavorModal.querySelectorAll('[data-apdp-flavor-close]').forEach(function (el) {
        el.addEventListener('click', closeFlavorModal);
      });
      function onEscape(e) {
        if (e.key === 'Escape' && !flavorModal.hidden) closeFlavorModal();
      }
      document.addEventListener('keydown', onEscape);
      disposers.push(function () { document.removeEventListener('keydown', onEscape); });
      flavorModal.querySelectorAll('[data-apdp-flavor-card]').forEach(function (card) {
        var qtyEl = card.querySelector('[data-apdp-flavor-qty]');
        var inc = card.querySelector('[data-apdp-flavor-inc]');
        var dec = card.querySelector('[data-apdp-flavor-dec]');
        function syncSelected() {
          var n = parseInt(qtyEl.textContent, 10) || 0;
          card.classList.toggle('is-selected', n > 0);
        }
        if (inc) inc.addEventListener('click', function () {
          if (busy || inc.disabled) return;
          var n = parseInt(qtyEl.textContent, 10) || 0;
          if (flavorRequired() === 1) {
            // Single choice: the chosen flavour's '+' is a no-op; any other replaces it.
            if (n > 0) return;
            flavorModal.querySelectorAll('[data-apdp-flavor-qty]').forEach(function (q) { q.textContent = '0'; });
            qtyEl.textContent = '1';
            updateFlavorCount();
            announceFlavor(card.getAttribute('data-selected-announcement') || '');
          } else {
            qtyEl.textContent = n + 1;
            syncSelected();
            updateFlavorCount();
            // Say once, on the step that fills the pack, why '+' stops working.
            announceFlavor(flavorTotal() >= flavorRequired() ? flavorHintText() : '');
          }
          keepFlavorFocus(inc, card);
        });
        if (dec) dec.addEventListener('click', function () {
          if (busy || dec.disabled) return;
          var n = parseInt(qtyEl.textContent, 10) || 0;
          if (n > 0) qtyEl.textContent = n - 1;
          syncSelected();
          updateFlavorCount();
          announceFlavor('');
          keepFlavorFocus(dec, card);
        });
      });
      var submitBtn = flavorModal.querySelector('[data-apdp-flavor-submit]');
      if (submitBtn) submitBtn.addEventListener('click', function () {
        if (submitBtn.disabled || busy) return;
        var picks = [];
        flavorModal.querySelectorAll('[data-apdp-flavor-card]').forEach(function (card) {
          var q = parseInt(card.querySelector('[data-apdp-flavor-qty]').textContent, 10) || 0;
          var vid = parseInt(card.getAttribute('data-variant-id'), 10);
          if (q > 0 && vid) {
            var nameEl = card.querySelector('[data-apdp-flavor-name]');
            picks.push({
              variantId: vid,
              qty: q,
              name: nameEl ? nameEl.textContent.trim() : 'Flavour ' + vid,
            });
          }
        });
        if (!picks.length) return;

        purchase(picks, submitBtn, 'checkout');
      });
    }

    // Add to cart
    if (cta) {
      var span = cta.querySelector('.apdp__cta-text');
      if (span) cta.dataset.originalLabel = span.textContent.trim();
      cta.addEventListener('click', function () {
        if (busy || cta.disabled) return;
        // Read and immediately reset the origin, so a later direct click on this
        // button is never mistaken for a sticky-bar one.
        var origin = addOrigin;
        addOrigin = 'main';
        // One-, two- and three-pack tiers all ask for flavour confirmation.
        if (flavorModal && openFlavorModal()) {
          return;
        }
        showToast('Flavour selection is unavailable. Please refresh the page and try again.', true);
      });
    }

    // ── Judge.me badge wording ───────────────────────────────────────────
    // Show "4.85/5 (678)" instead of the app's "678 reviews", built from the
    // rating and count Judge.me itself puts on the badge, so the numbers stay
    // real. The app rewrites this badge on load and again on every flavour
    // change, and it reports the average as "5.00" one time and "5" the next,
    // so watch the container and normalise rather than formatting once.
    (function initJudgemeText() {
      var wrap = sec.querySelector('[data-apdp-jdgm]');
      if (!wrap) return;
      function format() {
        var badge = wrap.querySelector('.jdgm-prev-badge');
        var textEl = wrap.querySelector('.jdgm-prev-badge__text');
        if (!badge || !textEl) return;
        var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;
        if (!count) return; // no reviews yet: leave the app's own wording alone
        var avg = parseFloat(badge.getAttribute('data-average-rating'));
        if (isNaN(avg)) return;
        var out = avg.toFixed(2).replace(/\.00$/, '') + '/5 (' + count + ')';
        // Bail when it already reads correctly, so writing the text cannot
        // retrigger this observer indefinitely.
        if (textEl.textContent.trim() === out) return;
        textEl.textContent = out;
      }
      format();
      if (window.MutationObserver) {
        observe(new MutationObserver(format), wrap, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    })();

    // ── Sticky bottom bar (desktop PDP) ──────────────────────────────────
    // A pure mirror of this section's purchase state. It owns no state: the
    // title, image, tier name, prices and CTA label/classes are copied from
    // the existing PDP elements, and its button simply proxies the main CTA
    // (same flavour modal, same cart payload, same quick-cart behaviour).
    (function initStickyBar() {
      var bar = sec.querySelector('[data-apdp-sticky]');
      if (!bar || !cta) return;
      var sTitle = bar.querySelector('[data-apdp-sticky-title]');
      var sSub = bar.querySelector('[data-apdp-sticky-sub]');
      var sPrice = bar.querySelector('[data-apdp-sticky-price]');
      var sCompare = bar.querySelector('[data-apdp-sticky-compare]');
      var sDisc = bar.querySelector('[data-apdp-sticky-discount]');
      var sImg = bar.querySelector('[data-apdp-sticky-img]');
      var sCta = bar.querySelector('[data-apdp-sticky-cta]');
      var sCtaText = bar.querySelector('[data-apdp-sticky-cta-text]');

      function textOf(el) { return el ? el.textContent.trim() : ''; }

      function syncSticky() {
        if (sTitle) sTitle.textContent = textOf(titleEl) || sTitle.textContent;
        // Thumb = the selected tier's pack image (the bundle card img, which
        // already carries the per-flavour custom.bundle_image_<n>_pack
        // metafield source and is swapped on flavour change). Falls back to
        // the main gallery image when a tier has no card image.
        var tierImg = selectedBundle ? selectedBundle.querySelector('[data-apdp-bundle-img]') : null;
        var srcEl = tierImg && tierImg.src ? tierImg : sec.querySelector('[data-apdp-main]');
        if (sImg && srcEl && srcEl.src && sImg.src !== srcEl.src) {
          sImg.src = srcEl.src;
          sImg.removeAttribute('srcset');
        }
        var b = selectedBundle;
        if (b) {
          if (sSub) sSub.textContent = b.getAttribute('data-name') || '';
          if (sPrice) sPrice.textContent = textOf(b.querySelector('.apdp__bundle-price'));
          if (sCompare) sCompare.textContent = textOf(b.querySelector('.apdp__bundle-price-old'));
          var d = textOf(b.querySelector('.apdp__bundle-discount'));
          if (sDisc) { sDisc.textContent = d; sDisc.hidden = !d; }
        } else {
          // No bundle tiers configured: fall back to the variant price row.
          if (sSub) sSub.textContent = '';
          if (sPrice) sPrice.textContent = textOf(priceEl);
          if (sCompare) sCompare.textContent = textOf(compareEl);
          if (sDisc) sDisc.hidden = true;
        }
        if (sCtaText) {
          var label = textOf(cta.querySelector('.apdp__cta-text'));
          if (label) sCtaText.textContent = label;
        }
        if (sCta) {
          sCta.disabled = cta.disabled;
          sCta.setAttribute('aria-busy', cta.classList.contains('is-loading') ? 'true' : 'false');
          sCta.classList.toggle('is-loading', cta.classList.contains('is-loading'));
          sCta.classList.toggle('is-added', cta.classList.contains('is-added'));
        }
      }

      // One rAF-debounced observer on the purchase column covers every change
      // path (tier click, flavour swap fetch, CTA label/state) without adding
      // per-control listeners. The bar lives outside the column, so syncing
      // never re-triggers the observer.
      var rightCol = sec.querySelector('.apdp__right');
      var queued = false;
      function queueSync() {
        if (queued) return;
        queued = true;
        frame(function () { queued = false; syncSticky(); });
      }
      if (rightCol && window.MutationObserver) {
        observe(new MutationObserver(queueSync), rightCol, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          // 'src': the bundle-card pack images swap on flavour change and the
          // bar thumb mirrors the selected tier's image.
          attributeFilter: ['class', 'src', 'disabled'],
        });
      }
      // The main gallery lives in the left column and its image swaps after
      // the flavour fetch - watch it too so the bar thumb never lags a flavour
      // behind.
      var gallery = sec.querySelector('.apdp__gallery') || sec.querySelector('.apdp__left');
      if (gallery && window.MutationObserver) {
        observe(new MutationObserver(queueSync), gallery, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['src'],
        });
      }

      // Proxy the main CTA so the flavour modal, cart payload and freebies stay
      // one implementation; the flag tells that handler the add started here, so
      // it refreshes the cart in place instead of opening the quick cart.
      if (sCta) sCta.addEventListener('click', function () {
        addOrigin = 'sticky';
        cta.click();
      });

      function visibility(visible) {
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        bar.inert = !visible;
      }
      // Anchor jumps can skip the intersecting state entirely. Geometry, rather
      // than an observer threshold transition, decides whether the CTA passed.
      var visibilityQueued = false;
      function syncVisibility() { visibility(cta.getBoundingClientRect().bottom <= 0); }
      function queueVisibility() {
        if (disposed || visibilityQueued) return;
        visibilityQueued = true;
        frame(function () { visibilityQueued = false; syncVisibility(); });
      }
      window.addEventListener('scroll', queueVisibility, { passive: true });
      window.addEventListener('resize', queueVisibility);
      window.addEventListener('pageshow', queueVisibility);
      var viewport = window.visualViewport;
      if (viewport) viewport.addEventListener('resize', queueVisibility);
      disposers.push(function () {
        window.removeEventListener('scroll', queueVisibility);
        window.removeEventListener('resize', queueVisibility);
        window.removeEventListener('pageshow', queueVisibility);
        if (viewport) viewport.removeEventListener('resize', queueVisibility);
      });
      if ('IntersectionObserver' in window) observe(new IntersectionObserver(queueVisibility), cta);
      syncVisibility();

      // Keyboard focus must stay clear of the bar (WCAG 2.4.11). A control that receives
      // focus underneath the shown bar (browsers do not scroll it when it is already in
      // the viewport) is scrolled up just enough. Skipped while the bar is not rendered,
      // e.g. when the dedicated sticky bundle bar section hides this one.
      function keepFocusClear(event) {
        var el = event.target;
        if (!bar.classList.contains('is-visible') || !el || !el.getBoundingClientRect || bar.contains(el)) return;
        var barRect = bar.getBoundingClientRect();
        if (!barRect.height) return;
        var rect = el.getBoundingClientRect();
        if (rect.bottom <= barRect.top || rect.top >= window.innerHeight) return;
        var headroom = rect.top - (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0);
        var delta = Math.min(rect.bottom - barRect.top + 16, Math.max(0, headroom));
        if (delta > 0) window.scrollBy(0, delta);
      }
      document.addEventListener('focusin', keepFocusClear);
      disposers.push(function () { document.removeEventListener('focusin', keepFocusClear); });

      syncSticky();
    })();
  }

  function initAll() {
    document.querySelectorAll('[data-apdp]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme-editor re-renders can execute this file again: the section lifecycle listeners
  // below are registered once per page (initSection itself is idempotent per section).
  if (window.AquonPdpBundleLifecycle) return;
  window.AquonPdpBundleLifecycle = true;
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-apdp]').forEach(initSection);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-apdp]').forEach(function (sec) {
      if (sec._apdpCleanup) sec._apdpCleanup();
    });
  });
})();

/* Accordion (Details / Delivery & Return style). Smooth height, one open at a
   time. Independent of the bundle logic above. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAcc(root) {
    if (root.dataset.apdpAccInit === '1') return;
    root.dataset.apdpAccInit = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('.apdp__acc-item'));
    function panelOf(item) { return item.querySelector('[data-apdp-acc-panel]'); }
    function headOf(item) { return item.querySelector('[data-apdp-acc-head]'); }

    function close(item, animate) {
      var head = headOf(item), panel = panelOf(item);
      if (!head || head.getAttribute('aria-expanded') !== 'true') return;
      head.setAttribute('aria-expanded', 'false');
      panel.inert = true;
      panel.setAttribute('aria-hidden', 'true');
      if (reduce || !animate) { panel.style.height = '0px'; return; }
      panel.classList.add('is-anim');
      panel.style.height = panel.scrollHeight + 'px';
      panel.getBoundingClientRect();
      panel.style.height = '0px';
    }
    function open(item) {
      var head = headOf(item), panel = panelOf(item);
      head.setAttribute('aria-expanded', 'true');
      panel.inert = false;
      panel.setAttribute('aria-hidden', 'false');
      if (reduce) { panel.style.height = 'auto'; return; }
      panel.classList.add('is-anim');
      panel.style.height = panel.scrollHeight + 'px';
      var done = function (e) {
        if (e.propertyName !== 'height') return;
        if (head.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
        panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
    }

    items.forEach(function (item) {
      var head = headOf(item);
      if (!head) return;
      head.addEventListener('click', function () {
        var isOpen = head.getAttribute('aria-expanded') === 'true';
        items.forEach(function (other) { if (other !== item) close(other, true); });
        if (isOpen) close(item, true); else open(item);
      });
    });
  }

  function initAll() { document.querySelectorAll('[data-apdp-acc]').forEach(initAcc); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  if (window.AquonPdpAccordionLifecycle) return;
  window.AquonPdpAccordionLifecycle = true;
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-apdp-acc]').forEach(initAcc);
  });
})();
